import { BrandLogo } from '@kontentino/ui';
import getSocialMediaTypeForBrandLogo from 'app/utils/getSocialMediaTypeForBrandLogo';
import { getYtLogoGuidelineSize } from 'app/utils/getytlogoguidelinesize';
import React, { FC } from 'react';

type Props = {
  option: {
    value: number;
    label: string;
    logoSrc: string;
    type: number;
  };
};

const ShiftTargetProjectOfProfileSelectOption: FC<Props> = ({ option }) => {
  return (
    <div className="tw-flex tw-items-center tw-gap-3">
      <BrandLogo
        src={option.logoSrc}
        name={option.label}
        size={28}
        socialMediaType={getSocialMediaTypeForBrandLogo(option.type)}
        iconSize={getYtLogoGuidelineSize(12, option.type)}
      />

      <div className="tw-max-w-[30rem] tw-overflow-hidden tw-text-ellipsis tw-whitespace-nowrap tw-text-md">
        {option.label}
      </div>
    </div>
  );
};

export default ShiftTargetProjectOfProfileSelectOption;
